// src/components/PaginationBar.jsx
import React from "react";
import { Stack, Typography, IconButton, Select, MenuItem, FormControl, InputLabel, Tooltip } from "@mui/material";
import FirstPageIcon  from "@mui/icons-material/FirstPage";
import LastPageIcon   from "@mui/icons-material/LastPage";
import ChevronLeftIcon  from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { C } from "../theme";

export default function PaginationBar({ page, pages, total, pageSize, onPageChange, onPageSizeChange, pageSizeOptions = [10,20,50,100], loading = false }) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to   = Math.min(page * pageSize, total);

  return (
    <Stack direction={{ xs:"column", sm:"row" }} alignItems="center" justifyContent="space-between" spacing={2} sx={{ mt:2, px:1, py:1 }}>
      <Typography variant="body2" color="text.secondary">
        {total === 0 ? "Aucun résultat" : `${from}–${to} sur ${total}`}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={0.25}>
        {[
          { title:"Première page",  icon:<FirstPageIcon fontSize="small" />,    disabled: page<=1, onClick:()=>onPageChange(1) },
          { title:"Page précédente",icon:<ChevronLeftIcon fontSize="small" />,  disabled: page<=1, onClick:()=>onPageChange(page-1) },
          null,
          { title:"Page suivante",  icon:<ChevronRightIcon fontSize="small" />, disabled: page>=pages, onClick:()=>onPageChange(page+1) },
          { title:"Dernière page",  icon:<LastPageIcon fontSize="small" />,     disabled: page>=pages, onClick:()=>onPageChange(pages) },
        ].map((item, i) => item === null ? (
          <Typography key={i} variant="body2" sx={{ px:1.5, minWidth:80, textAlign:"center", color:"text.secondary" }}>
            {page} / {pages}
          </Typography>
        ) : (
          <Tooltip key={i} title={item.title}>
            <span>
              <IconButton size="small" onClick={item.onClick} disabled={item.disabled || loading}
                sx={{ borderRadius:2, "&:hover": { background: C.slate[100] } }}>
                {item.icon}
              </IconButton>
            </span>
          </Tooltip>
        ))}
      </Stack>

      <FormControl size="small" sx={{ minWidth:110 }}>
        <InputLabel>Par page</InputLabel>
        <Select label="Par page" value={pageSize} disabled={loading}
          onChange={e => { onPageSizeChange(Number(e.target.value)); onPageChange(1); }}>
          {pageSizeOptions.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
        </Select>
      </FormControl>
    </Stack>
  );
}
